'use strict';

/**
 * Author:fanglijuan
 *
 * Time:2019-04-24
 */
angular.module('quickSignAllmanuscriptModule', []).controller('quickSignAllmanuscriptCtrl', ['$scope', '$sce', '$q', '$modal', '$timeout', '$state', '$location', '$window', '$filter', 'trsHttpService', '$stateParams', 'editcenterRightsService', 'modalDialog', 'editingCenterService', 'localStorageService', 'initSingleSelecet', 'appQuickSignService',
    function($scope, $sce, $q, $modal, $timeout, $state, $location, $window, $filter, trsHttpService, $stateParams, editcenterRightsService, modalDialog, editingCenterService, localStorageService, initSingleSelecet, appQuickSignService) {
        initStatus();
        initData();

        /**
         * [initStatus description]初始化页面参数
         * @return {[type]} [description]null
         */
        function initStatus() {
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 10,
                ITEMCOUNT: 0,
                PAGECOUNT: 1,
            };
            $scope.data = {
                items: [],
                selectedArray: [],
            };
            $scope.status = {
                keywords: '',
                copyCurrPage: 1,
            };
            $scope.params = {
                serviceid: 'mlf_appquickpublish',
                methodname: 'queryRels',
                CURRPAGE: $scope.page.CURRPAGE,
                PAGESIZE: $scope.page.PAGESIZE,
                // CHANNELID: $stateParams.channelid,
                SITEID: $stateParams.siteid,
                reltype: 1, // 关联类型:1为稿件，2为推送
                ismine: 0, // 默认全部，0为查询所有 1为查询用户
                status: 2,
                keyword: $scope.status.keywords,
            };
        }

        /**
         * [initData description]初始化页面数据
         * @return {[type]} [description]null
         */
        function initData() {
            requestData();
        }
        
        /**
         * [fullTextSearch description;全文检索]
         * @param  {[type]} ev [description:按下空格也能提交]
         */
        $scope.fullTextSearch = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                $scope.params.keyword = $scope.status.keywords;
                $scope.page.CURRPAGE = 1;
                requestData();
            }
        };

        /**
         * [requestData description]获取列表数据
         * @return {[type]} [description]
         */
        function requestData() {
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'post').then(function(data) {
                $scope.data.items = data.DATA;
                $scope.page = data.PAGER;
            });
        }

        /**
         * [pageChanged description]下一页
         * @return {[type]} [description] null
         */
        $scope.pageChanged = function() {
            $scope.params.CURRPAGE = $scope.page.CURRPAGE;
            $scope.status.copyCurrPage = $scope.page.CURRPAGE;
            requestData();
        };
        // 选择单页显示个数
        $scope.selectPageNum = function() {
            $scope.params.PAGESIZE = $scope.page.PAGESIZE;
            $scope.params.CURRPAGE = $scope.page.CURRPAGE;
            $scope.status.copyCurrPage = 1;
            requestData();
        };

        /**
         * [jumpToPage description] 跳转到指定页面
         * @return {[type]} [description]
         */
        $scope.jumpToPage = function() {
            if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
            }
            if ($scope.status.copyCurrPage < 1) {
                $scope.status.copyCurrPage = 1;
            }
            $scope.params.CURRPAGE = $scope.status.copyCurrPage;
            requestData();
        };
    }
]);
